"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyReturnAssetsType = exports.ComoUserInputType = exports.LoyaltyProviderType = exports.LoyaltyRewardStatus = exports.ComoMemberStatus = void 0;
var ComoMemberStatus;
(function (ComoMemberStatus) {
    ComoMemberStatus[ComoMemberStatus["Active"] = 1] = "Active";
    ComoMemberStatus[ComoMemberStatus["Inactive"] = 2] = "Inactive";
    ComoMemberStatus[ComoMemberStatus["Expired"] = 3] = "Expired";
    ComoMemberStatus[ComoMemberStatus["Pending"] = 4] = "Pending";
})(ComoMemberStatus = exports.ComoMemberStatus || (exports.ComoMemberStatus = {}));
var LoyaltyRewardStatus;
(function (LoyaltyRewardStatus) {
    LoyaltyRewardStatus[LoyaltyRewardStatus["Active"] = 1] = "Active";
    LoyaltyRewardStatus[LoyaltyRewardStatus["Redeemed"] = 2] = "Redeemed";
    LoyaltyRewardStatus[LoyaltyRewardStatus["Deactivated"] = 3] = "Deactivated";
    LoyaltyRewardStatus[LoyaltyRewardStatus["Expired"] = 4] = "Expired";
    LoyaltyRewardStatus[LoyaltyRewardStatus["Future"] = 5] = "Future";
    LoyaltyRewardStatus[LoyaltyRewardStatus["InProgress"] = 6] = "InProgress";
})(LoyaltyRewardStatus = exports.LoyaltyRewardStatus || (exports.LoyaltyRewardStatus = {}));
var LoyaltyProviderType;
(function (LoyaltyProviderType) {
    LoyaltyProviderType[LoyaltyProviderType["None"] = 0] = "None";
    LoyaltyProviderType[LoyaltyProviderType["Como"] = 1] = "Como";
})(LoyaltyProviderType = exports.LoyaltyProviderType || (exports.LoyaltyProviderType = {}));
var ComoUserInputType;
(function (ComoUserInputType) {
    ComoUserInputType[ComoUserInputType["PhoneNumber"] = 1] = "PhoneNumber";
    ComoUserInputType[ComoUserInputType["SMSConfirmation"] = 2] = "SMSConfirmation";
})(ComoUserInputType = exports.ComoUserInputType || (exports.ComoUserInputType = {}));
var LoyaltyReturnAssetsType;
(function (LoyaltyReturnAssetsType) {
    LoyaltyReturnAssetsType[LoyaltyReturnAssetsType["Active"] = 0] = "Active";
    LoyaltyReturnAssetsType[LoyaltyReturnAssetsType["Inactive"] = 1] = "Inactive";
    LoyaltyReturnAssetsType[LoyaltyReturnAssetsType["All"] = 2] = "All";
})(LoyaltyReturnAssetsType = exports.LoyaltyReturnAssetsType || (exports.LoyaltyReturnAssetsType = {}));
